<template>
  <div v-if="rateControl" class="player-speed">
    <button
      class="player-speed__btn player-speed__btn--up"
      @click="rateControl.up()"
    >
      <span class="iconfont iplayer-fast"></span>
    </button>
    <span class="player-speed__text" @click="rateControl.reset()">
      {{ formatRate(playbackRate) }}
    </span>
    <button
      class="player-speed__btn player-speed__btn--down"
      @click="rateControl.down()"
    >
      <span class="iconfont iplayer-slow"></span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { RateControl, AudioDoc } from '@/services/player'
import { assertNotNull } from '@/helpers/typing'

const props = defineProps<{
  audio: AudioDoc
}>()

const rateControl = ref<RateControl | null>(null)

onMounted(() => {
  rateControl.value = new RateControl(props.audio)
})

function formatRate(rate: number): string {
  const result = (Math.round(rate * 10) / 10).toLocaleString(undefined, {
    minimumFractionDigits: 1,
  })
  return `${result}x`
}

/**
 * Expose playback rate as reactive property.
 *
 * If we just use `rateControl.rate()` inside the view (event if it is made property),
 * it doesn't work and changes are not reflected in the view.
 */
const playbackRate = computed(() => {
  return assertNotNull(rateControl.value).rate()
})
</script>
